import Vue from 'vue'
import Router from 'vue-router'
import {baseUrl, Url} from '../config/CONSTANTS';
import store from "../store";
import  routers from "./config";

Vue.use(Router);
let client;
let dev = window.navigator.userAgent.toLocaleLowerCase().match(/MicroMessenger/i);
if (dev && dev[0] === 'micromessenger') {
    client = 0
} else {
    client =1
}
// const context = require.context('../views', true, /router\.js$/);
// const routers = context
// 	.keys()
// 	.map(item => context(item).default);
    
const router = new Router({
	mode: 'history',
	routes: [
		{ path: '*',
			redirect: '/'
		},
		...routers
	]
});

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
    if (from.meta.keepAlive) {
        const $content = document.getElementsByClassName('bg')[0];
        const scrollTop = $content ? $content.scrollTop : 0;
        from.meta.scrollTop = scrollTop;
    }
	next();
});

router.afterEach(route => {
    // 从路由的元信息中获取 title 属性
    if (route.meta.title == '幸运抽奖' && client == 1) {
        document.title = route.meta.title;
        // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
        if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
            const hackIframe = document.createElement('iframe');
            hackIframe.style.display = 'none';
            hackIframe.src = '/static/html/fixIosTitle.html?r=' + Math.random();
            document.body.appendChild(hackIframe);
            setTimeout(_ => {
                document.body.removeChild(hackIframe)
            }, 300)
        }
    }
});

router.afterEach((to, from) => {        //     伸手党福利
    if (window.__wxjs_is_wkwebview == true) {  // IOS
        if (window.entryUrl == '' || window.entryUrl == undefined) {
            var url = `${location.origin}${to.fullPath}`
            // var url = Url + encodeURIComponent(to.fullPath)
            window.entryUrl = url    // 将后面的参数去除
        }
    }else {       // 安卓
        window.entryUrl = '';
    }
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js